namespace TabAurous.OMS {
    export interface SieveSizeMappingRow {
        Id?: number;
        ShapeId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        FromWeight?: number;
        ToWeight?: number;
        ParentId?: number;
        IsParent?: boolean;
        Shape?: string;
        Size?: string;
        Sieve?: string;
        Parent?: string;
        Length?: string;
        Width?: string;
        Depth?: string;
        ProductTypeId?: number;
        SubCategoryId?: number;
    }

    export namespace SieveSizeMappingRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'OMS.SieveSizeMapping';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ShapeId = "ShapeId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            FromWeight = "FromWeight",
            ToWeight = "ToWeight",
            ParentId = "ParentId",
            IsParent = "IsParent",
            Shape = "Shape",
            Size = "Size",
            Sieve = "Sieve",
            Parent = "Parent",
            Length = "Length",
            Width = "Width",
            Depth = "Depth",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId"
        }
    }
}
